import { SubtasksModule } from './../subtasks/subtasks.module';
import { CommentaryModule } from '@shared/modules/commentary/commentary.module';
import { TasksModule } from './../tasks/tasks.module';
import { SharedModule } from '@shared/shared.module';
import { GbxsoftFormModule } from '@form/src/public-api';
import { TASK_SIDENAV_COMPONENTS_EXPORT, TASK_SIDENAV_COMPONENTS } from '.';
import { NgModule } from '@angular/core';
import { AttachmentsManageModule } from '../attachment-manage/attachments-manage.module';
import { CoreModule } from '@core/core.module';
import { FormsV2Module } from '../forms-v2/forms-v2.module';
@NgModule({
  declarations: [TASK_SIDENAV_COMPONENTS, TASK_SIDENAV_COMPONENTS_EXPORT],
  imports: [
    CoreModule,
    SharedModule,
    GbxsoftFormModule,
    AttachmentsManageModule,
    CommentaryModule,
    TasksModule,
    SubtasksModule,
    FormsV2Module
  ],
  exports: [TASK_SIDENAV_COMPONENTS_EXPORT],
  providers: []
})
export class TaskSidenavModule {}
